import { NavLink } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  openContactModal: () => void;
}

const MobileMenu = ({ isOpen, onClose, openContactModal }: MobileMenuProps) => {
  if (!isOpen) return null;

  const handleContactClick = () => {
    openContactModal();
    onClose(); // Close the mobile menu when opening contact modal
  };

  return (
    <div className="fixed inset-0 z-50 bg-background/95 backdrop-blur-sm md:hidden font-sans">
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-end mb-8">
          <button onClick={onClose} className="text-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="flex flex-col space-y-6">
          <NavLink 
            to="/" 
            className={({ isActive }) => 
              `text-lg font-medium ${isActive ? 'text-primary' : 'text-foreground'}`
            }
            onClick={onClose}
          >
            Home
          </NavLink>
          <NavLink 
            to="/mobile-app-designs" 
            className={({ isActive }) => 
              `text-lg font-medium ${isActive ? 'text-primary' : 'text-foreground'}`
            }
            onClick={onClose}
          >
            Mobile Apps
          </NavLink>   <NavLink 
            to="/logo-designs" 
            className={({ isActive }) => 
              `text-lg font-medium ${isActive ? 'text-primary' : 'text-foreground'}`
            }
            onClick={onClose}
          >
            Logo Designs
          </NavLink>
          <NavLink 
            to="/flyer-designs" 
            className={({ isActive }) => 
              `text-lg font-medium ${isActive ? 'text-primary' : 'text-foreground'}`
            }
            onClick={onClose}
          >
            Flyer Designs
          </NavLink>
    
          <NavLink 
            to="/ux-designs" 
            className={({ isActive }) => 
              `text-lg font-medium ${isActive ? 'text-primary' : 'text-foreground'}`
            }
            onClick={onClose}
          >
            UX Designs
          </NavLink>
          
            <div className="pt-4 mt-4 border-t border-gray-700">
              <motion.button 
                onClick={handleContactClick}
                className="flex items-center justify-center w-4/5 mx-auto bg-transparent text-white border border-coral rounded-full py-1.5 px-4 text-xs transition-colors hover:bg-coral/10"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <MessageCircle className="w-2.5 h-2.5 mr-1" />
                Build with us
              </motion.button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu; 